import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store(
	{
		state:
		{
			lang: 'jp',
			apiPath: '/psgi/user/pub-api/passwd_reset/',
			basePath: '/user/password/',
		},
		mutations:
		{
			setLang: (state, payload) =>
			{
				state.lang = payload.lang || state.lang;
			},
		},
		actions: {},
	},
);
